var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6C17.5 6 18.5369 6.00102 18.5552 6.00306C18.8297 6.03355 19.0274 6.28076 18.9969 6.55522L17.9475 16H6.05248C6.05248 16 5 6.51845 5 6.5C5 6.22386 5.22386 6 5.5 6H6.5C6.77614 6 7 6.22386 7 6.5V7C7 8.10457 7.89543 9 9 9C10.1046 9 11 8.10457 11 7V6.5C11 6.22386 11.2239 6 11.5 6H12.5C12.7761 6 13 6.22386 13 6.5V7C13 8.10457 13.8954 9 15 9C16.1046 9 17 8.10457 17 7V6.5C17 6.22386 17.2239 6 17.5 6ZM6 17H18V18H6V17Z",
    fill: "#116DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumBlue);
export default __webpack_public_path__ + "static/media/premium_blue.a8a9327216aec5a25d36854fb836e422.svg";
export { ForwardRef as ReactComponent };